import styled from 'styled-components'

import Link from '@ntuctech/devex-tangram/Link'

export const FormAction = styled.div`
  margin-top: 0.5rem;
  width: 100%;
  display: flex;
  justify-content: ${props =>
    props.align === 'r' ? 'flex-end' : 'flex-start'};

  & button._ndsBtn--compact {
    margin-right: ${props => (props.align === 'r' ? '0' : '0.5')}rem !important;
    margin-left: ${props => (props.align === 'r' ? '0.5' : '0')}rem !important;
  }
`

export const FormContentWrapper = styled.div`
  margin-top: 0.5rem;
  width: 100%;
  position: relative;

  & .hide {
    display: none;
  }
`

export const ActionLink = styled(Link)`
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;

  &:hover {
    box-shadow: none;
  }
`
